import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const HelpSidebar = ({ className = '' }) => {
  const [activeTab, setActiveTab] = useState('tips');

  const helpTips = [
    {
      id: 1,
      title: 'انتخاب نوع پرونده',
      content: `برای انتخاب صحیح نوع پرونده، ابتدا ماهیت مسئله حقوقی خود را مشخص کنید:\n• اظهارنامه قضایی: برای ارائه اطلاعات و مدارک به دادگاه\n• شکایت: برای طرح ادعا علیه شخص یا نهاد دیگر\n• لایحه: برای پاسخ به شکایت یا ارائه دفاعیات`,
      icon: 'FileText',
    },
    {
      id: 2,
      title: 'نحوه تکمیل اطلاعات طرفین',
      content: `اطلاعات طرفین را به صورت کامل و دقیق وارد کنید:\n• نام و نام خانوادگی کامل\n• در صورت وجود، شماره ملی یا شناسه حقوقی\n• آدرس دقیق محل سکونت یا فعالیت\n• شماره تماس معتبر`,
      icon: 'Users',
    },
    {
      id: 3,
      title: 'نگارش موضوع و توضیحات',
      content: `برای نگارش مؤثر موضوع و توضیحات:\n• موضوع را خلاصه و مفهوم بنویسید\n• در توضیحات، تمام جزئیات مهم را ذکر کنید\n• از زبان رسمی و حقوقی استفاده کنید\n• تاریخ‌ها و مبالغ را دقیق وارد کنید`,
      icon: 'Edit3',
    },
  ];

  const examples = [
    {
      id: 1,
      type: 'اظهارنامه قضایی',
      subject: 'اظهارنامه مالکیت ملک واقع در تهران',
      description: `بدینوسیله اظهار می‌دارم که ملک واقع در آدرس تهران، خیابان ولیعصر، پلاک ۱۲۳ متعلق به اینجانب می‌باشد و سند مالکیت آن به شماره ۴۵۶۷۸۹ در دفتر اسناد رسمی شماره ۱۰ تهران ثبت گردیده است.\n\nدر حال حاضر شخص ثالثی بدون حق، ملک مذکور را تصرف نموده و از تخلیه آن خودداری می‌نماید.`,
    },
    {
      id: 2,
      type: 'شکایت',
      subject: 'شکایت از عدم پرداخت مطالبات',
      description: `بدینوسیله از آقای احمد محمدی به دلیل عدم پرداخت مبلغ ۵۰،۰۰۰،۰۰۰ ریال بابت خرید کالا طبق قرارداد مورخ ۱۴۰۲/۰۵/۱۵ شکایت می‌نمایم.\n\nعلی‌رغم مراجعات متعدد و اعذار قانونی، خوانده از پرداخت مطالبات خودداری نموده است.`,
    },
  ];

  return (
    <div
      className={`bg-card border border-border rounded-lg overflow-hidden ${className}`}>
      {/* Header Tabs */}
      <div className="flex border-b border-border">
        <button
          onClick={() => setActiveTab('tips')}
          className={`flex-1 px-4 py-3 text-sm font-medium transition-colors duration-150 ${
            activeTab === 'tips'
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted'
          }`}>
          راهنمای تکمیل
        </button>
        <button
          onClick={() => setActiveTab('examples')}
          className={`flex-1 px-4 py-3 text-sm font-medium transition-colors duration-150 ${
            activeTab === 'examples'
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted'
          }`}>
          نمونه‌ها
        </button>
      </div>
      {/* Content */}
      <div className="p-4 max-h-96 overflow-y-auto">
        {activeTab === 'tips' && (
          <div className="space-y-4">
            {helpTips?.map((tip) => (
              <div key={tip?.id} className="space-y-2">
                <div className="flex items-center space-x-2 space-x-reverse">
                  <Icon name={tip?.icon} size={16} className="text-primary" />
                  <h3 className="font-medium text-foreground text-sm">
                    {tip?.title}
                  </h3>
                </div>
                <p className="text-sm text-muted-foreground leading-relaxed whitespace-pre-line">
                  {tip?.content}
                </p>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'examples' && (
          <div className="space-y-4">
            {examples?.map((example) => (
              <div
                key={example?.id}
                className="border border-border rounded-lg p-3">
                <div className="flex items-center space-x-2 space-x-reverse mb-2">
                  <span className="inline-flex items-center px-2 py-1 rounded-md text-xs font-medium bg-accent text-accent-foreground">
                    {example?.type}
                  </span>
                </div>
                <h4 className="font-medium text-foreground text-sm mb-2">
                  {example?.subject}
                </h4>
                <p className="text-xs text-muted-foreground leading-relaxed whitespace-pre-line">
                  {example?.description}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HelpSidebar;
